import React from 'react';
import { createComponent } from '@lit/react';
import { IxFab as IxFabLit } from '../IxFab.js';

customElements.define('ix-fab', IxFabLit);

export const IxFab = createComponent({
  tagName: 'ix-fab-react',
  elementClass: IxFabLit,
  react: React,
  events: {
    onclick: 'onClick',
  },
});
